<!-- Strengths and Areas for Improvement -->
<div class="strengths-improvement-section" *ngIf="hasData()">
  <mat-card class="strengths-improvement-card" *ngIf="showCard">
    <mat-card-header>
      <mat-card-title>{{ title }}</mat-card-title>
      <mat-card-subtitle>{{ subtitle }}</mat-card-subtitle>
    </mat-card-header>
    <mat-card-content>
      <div class="brand-analysis-grid">
        <!-- Single Brand Analysis -->
        <div *ngIf="shouldShowSingleBrand()" class="single-brand-analysis">
          <div class="analysis-card">
            <div class="brand-header">
              <h4>{{ getSingleBrand()?.name || 'Brand' }}</h4>
            </div>

            <div class="sections-wrapper">
              <div class="strengths-section">
                <div class="section-header">
                  <div class="section-indicator strengths-indicator"></div>
                  <h5>Strengths:</h5>
                </div>
                <ul class="analysis-list">
                  <li *ngFor="let strength of getSingleBrand()?.strengths">{{ strength }}</li>
                </ul>
              </div>

              <div class="improvement-section">
                <div class="section-header">
                  <div class="section-indicator improvement-indicator"></div>
                  <h5>Areas for Improvement:</h5>
                </div>
                <ul class="analysis-list">
                  <li *ngFor="let improvement of getSingleBrand()?.improvements">{{ improvement }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>

        <!-- Multiple Brands Analysis -->
        <div *ngIf="shouldShowMultipleBrands()" class="multiple-brands-analysis">
          <div class="brand-analysis-card" *ngFor="let brand of getMultipleBrands(); let i = index">
            <div class="brand-header">
              <h4>{{ brand.name }}</h4>
              <span class="you-badge" *ngIf="isYouBrand(brand)">(YOU)</span>
            </div>

            <div class="sections-wrapper">
              <div class="strengths-section">
                <div class="section-header">
                  <div class="section-indicator strengths-indicator"></div>
                  <h5>Strengths:</h5>
                </div>
                <ul class="analysis-list">
                  <li *ngFor="let strength of brand.strengths">{{ strength }}</li>
                </ul>
              </div>

              <div class="improvement-section">
                <div class="section-header">
                  <div class="section-indicator improvement-indicator"></div>
                  <h5>Areas for Improvement:</h5>
                </div>
                <ul class="analysis-list">
                  <li *ngFor="let improvement of brand.improvements">{{ improvement }}</li>
                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>
    </mat-card-content>
  </mat-card>

  <!-- Without card wrapper -->
  <div *ngIf="!showCard" class="brand-analysis-grid">
    <!-- Single Brand Analysis -->
    <div *ngIf="shouldShowSingleBrand()" class="single-brand-analysis">
      <div class="analysis-card">
        <div class="brand-header">
          <h4>{{ getSingleBrand()?.name || 'Brand' }}</h4>
        </div>

        <div class="sections-wrapper">
          <div class="strengths-section">
            <div class="section-header">
              <div class="section-indicator strengths-indicator"></div>
              <h5>Strengths:</h5>
            </div>
            <ul class="analysis-list">
              <li *ngFor="let strength of getSingleBrand()?.strengths">{{ strength }}</li>
            </ul>
          </div>

          <div class="improvement-section">
            <div class="section-header">
              <div class="section-indicator improvement-indicator"></div>
              <h5>Areas for Improvement:</h5>
            </div>
            <ul class="analysis-list">
              <li *ngFor="let improvement of getSingleBrand()?.improvements">{{ improvement }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Multiple Brands Analysis -->
    <div *ngIf="shouldShowMultipleBrands()" class="multiple-brands-analysis">
      <div class="brand-analysis-card" *ngFor="let brand of getMultipleBrands(); let i = index">
        <div class="brand-header">
          <h4>{{ brand.name }}</h4>
          <span class="you-badge" *ngIf="isYouBrand(brand)">(YOU)</span>
        </div>

        <div class="sections-wrapper">
          <div class="strengths-section">
            <div class="section-header">
              <div class="section-indicator strengths-indicator"></div>
              <h5>Strengths:</h5>
            </div>
            <ul class="analysis-list">
              <li *ngFor="let strength of brand.strengths">{{ strength }}</li>
            </ul>
          </div>

          <div class="improvement-section">
            <div class="section-header">
              <div class="section-indicator improvement-indicator"></div>
              <h5>Areas for Improvement:</h5>
            </div>
            <ul class="analysis-list">
              <li *ngFor="let improvement of brand.improvements">{{ improvement }}</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
